import React, { useContext, useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";

import LimitSearch from "../components/layout/LimitSearch";
import SearchBy from "../components/SearchBy";
import ClientList from "../components/Client/ClientList";
import { ClientContext } from "../context/Client/ClientContext";
import { GlobalContext } from "../context/GlobalContext";

const HomePage = () => {
  const { isShowClientList } = useContext(ClientContext);
  const { showLimitSearchBool, showSearchBy } = useContext(GlobalContext);

  const listRef = useRef(null);

  useEffect(() => {
    if (isShowClientList && window.innerWidth < 1200) {
      const scrollTimer = setTimeout(() => {
        listRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 150);

      return () => clearTimeout(scrollTimer);
    }
  }, [isShowClientList]);

  return (
    <div id="homePage" className="gog-page gog-page-spaced gog-home-page">
      {/* HERO */}
      <section className="gog-home-hero">
        <div className="gog-home-hero-content">
          <span className="gog-eyebrow">Merchant Directory</span>

          <h1>Find the right merchant faster.</h1>

          <p>
            Search GiveOrGo merchants by location, gift card availability,
            promotions, web store access, categories, and keywords.
          </p>
        </div>

        <div className="gog-home-hero-card">
          <strong>Search Flow</strong>
          <span>Limit Search → Search By → Results</span>
        </div>
      </section>

      {/* MAIN SEARCH LAYOUT */}
      <section className="gog-home-shell">
        {/* LEFT SEARCH PANEL */}
        <div className="gog-home-search-column">
          <CSSTransition
            timeout={300}
            classNames="slideFromTop"
            in={showLimitSearchBool}
            unmountOnExit
          >
            <div className="gog-panel gog-home-panel">
              <div className="gog-section-header">
                <span>Step 1</span>
                <h2>Limit your search</h2>
                <p>
                  Narrow the directory using location, gift card, promotion, and
                  web store filters.
                </p>
              </div>

              <LimitSearch />
            </div>
          </CSSTransition>

          <CSSTransition
            timeout={300}
            classNames="slideFromBottom"
            in={showSearchBy}
            unmountOnExit
          >
            <div className="gog-panel gog-home-panel">
              <div className="gog-section-header">
                <span>Step 2</span>
                <h2>Search by details</h2>
                <p>
                  Choose how you want to search for matching businesses and
                  services.
                </p>
              </div>

              <SearchBy />
            </div>
          </CSSTransition>
        </div>

        {/* RIGHT RESULTS PANEL */}
        <div className="gog-home-results-column" ref={listRef}>
          <CSSTransition
            timeout={300}
            classNames="fade"
            in={isShowClientList}
            unmountOnExit
          >
            <div className="gog-content-card gog-home-results-card">
              <div className="gog-section-header">
                <span>Results</span>
                <h2>Matching merchants</h2>
                <p>
                  Select a merchant to view their details, gift card options,
                  promotions, web store, and contact information.
                </p>
              </div>

              <ClientList />
            </div>
          </CSSTransition>

          {!isShowClientList && (
            <div className="gog-content-card gog-home-empty-card">
              <div className="gog-empty-state">
                <strong>Start your search</strong>
                <p>
                  Use the filters on the left to find merchants that match what
                  you are looking for.
                </p>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default HomePage;